export default __webpack_public_path__ + "static/media/defaultPin.28737af4.svg";